export default __webpack_public_path__ + "static/media/elon.04c18389.jpg";